import AdminCMSList from "@/pages/admin/AdminCMSList";

const CATEGORIES = [
  { value: "idea", label: "Idea Contributors" },
  { value: "ambassador", label: "Campus Ambassadors" },
  { value: "early", label: "Early Supporters" },
  { value: "event", label: "Event Partners" },
  { value: "brand", label: "Brand Contributors" },
  { value: "special", label: "Special Recognition" },
  { value: "supporter", label: "Supporters" },
];

export default function AdminContributors() {
  return (
    <AdminCMSList
      testIdPrefix="admin-contrib" title="Contributor" subtitle="Wall of Contributors"
      listEndpoint="/admin/contributors"
      createEndpoint="/admin/contributors"
      updateEndpoint={(id) => `/admin/contributors/${id}`}
      deleteEndpoint={(id) => `/admin/contributors/${id}`}
      blank={{ name: "", role: "", category: "supporter", description: "", image_url: "", link_url: "", is_visible: true, sort_order: 0 }}
      fields={[
        { key: "name", label: "Name", full: true },
        { key: "role", label: "Role" },
        { key: "category", label: "Category", type: "select", options: CATEGORIES },
        { key: "description", label: "Description", type: "textarea", full: true, rows: 2 },
        { key: "image_url", label: "Image URL", full: true },
        { key: "link_url", label: "Link URL (optional)", full: true },
        { key: "sort_order", label: "Sort order", type: "number" },
        { key: "is_visible", label: "Visible on site", type: "checkbox" },
      ]}
      renderCard={(c) => (
        <div className="p-5 text-center">
          <div className="aspect-square rounded-full overflow-hidden mx-auto bg-brand-muted w-20">
            {c.image_url ? <img src={c.image_url} alt={c.name} className="h-full w-full object-cover" /> : <div className="h-full w-full grid place-items-center font-display text-2xl text-brand-charcoal/40">{c.name.charAt(0)}</div>}
          </div>
          <div className="font-display text-lg mt-3">{c.name}</div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-brand-red mt-1">{c.role}</div>
          <div className="text-[10px] text-brand-charcoal/55 mt-1">{c.category}</div>
        </div>
      )}
    />
  );
}
